import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { EMPLOYEE_STATUS, loadOrgEmployeesByStatus } from './actions/load-org-employees-by-status';
import { employeesForOrgIdSelector } from '../reducers/employee-selectors';

import { UiButton } from '../ui/ui-button';

import { issueFilters } from './employee-list';

import Message from '../widgets/legacy-message';

const mapStateToProps = (state: any, { orgId }: InputProps) => ({
  employees: employeesForOrgIdSelector(state, orgId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { orgId }: InputProps,
) => ({
  actions: {
    loadEmployees: () => dispatch(loadOrgEmployeesByStatus(orgId, EMPLOYEE_STATUS.CURRENT)),
  },
});

type InputProps = {
  orgId: number;
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & StateProps & DispatchProps;

// Can probably be removed in PROD-4039 since all contact info errors are in the employee directory
export const EmployeeInvalidPhoneNumberWarning = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Props) => {
  const { actions, employees, orgId } = props;
  useEffect(() => {
    actions.loadEmployees();
  });

  const currentEmployees = employees.filter((e) => e.isCurrentEmployee);
  const employeesWithInvalidPhoneNumbers = issueFilters.invalidPhoneNumber.filter(currentEmployees);
  if (employeesWithInvalidPhoneNumbers.length === 0) {
    return null;
  }

  const link = issueFilters.invalidPhoneNumber.link(orgId);

  return (
    <Message variant="error" canBeDismissed={false}>
      <div className="u-spread">
        <div>
          <Link to={link}>
            {employeesWithInvalidPhoneNumbers.length}{' '}
            {employeesWithInvalidPhoneNumbers.length === 1 ? 'person has' : 'people have'} an
            invalid phone number, and can&apos;t receive any text messages.
          </Link>
        </div>
        <UiButton linkTo={link}>View Issues</UiButton>
      </div>
    </Message>
  );
});
